"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.headersMasked = exports.headersUnmasked = void 0;
exports.headersUnmasked = [
    {
        key: 'transactionId',
        value: 'transactionId',
    },
    {
        key: 'serviceName',
        value: 'serviceName',
    },
    {
        key: 'poid',
        value: 'poid',
    },
    {
        key: 'flowType',
        value: 'flowType',
    },
    {
        key: 'subFlowType',
        value: 'subFlowType',
    },
    {
        key: 'userType',
        value: 'userType',
    },
    {
        key: 'origin',
        value: 'Origin',
    },
    {
        key: 'from',
        value: 'From',
    },
    {
        key: 'host',
        value: 'Host',
    },
    {
        key: 'User-Agent',
        value: 'User-Agent',
    },
    {
        key: 'Cache-Control',
        value: 'Cache-Control',
    },
    {
        key: 'sec-ch-ua',
        value: 'Sec-ch-ua',
    },
    {
        key: 'referer',
        value: 'Referer',
    },
    {
        key: 'sec-ch-ua-mobile',
        value: 'Sec-ch-ua-mobile',
    },
    {
        key: 'sec-ch-ua-platform',
        value: 'Sec-ch-ua-platform',
    },
    {
        key: 'Content-Type',
        value: 'Content-Type',
    },
    {
        key: 'X-Amzn-Trace-Id',
        value: 'X-Amzn-Trace-Id',
    },
    {
        key: 'vgClientPoid',
        value: 'vgClientPoid',
    },
    {
        key: 'vgCallChain',
        value: 'vgCallChain',
    },
    {
        key: 'vgReferer',
        value: 'vgReferer',
    },
];
exports.headersMasked = [
    {
        key: 'X-Forwarded-For',
        value: 'X-Forwarded-For',
        maskLength: 4,
    },
];
